module.exports = __webpack_public_path__ + "img/倒數開始_2.17151097.png";